import React from "react";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";

import { MainContainer, WholeWrapper } from "./components";

const PageOutline = ({ children, header }) => {
  return (
    <WholeWrapper>
      <Sidebar />
      <MainContainer>
        {header && <Header {...header} />}
        {children}
      </MainContainer>
    </WholeWrapper>
  );
};

export default PageOutline;
